/** Внешность персонажей: цвета и детали, из которых код рисует спрайт на карте и портрет в окне диалога. */
export type HairStyle = 'short' | 'long' | 'bun' | 'curly' | 'bald' | 'cap' | 'beanie';
export type Extra = 'glasses' | 'beard' | 'headset' | 'apron' | 'tie' | 'backpack' | 'collar';

export interface CharLook {
  skin: string;
  hair: string;
  hairStyle: HairStyle;
  top: string;
  bottom: string;
  /** Шапка, кепка, галстук, рюкзак. */
  accent: string;
  extras: Extra[];
}

const SKIN = { light: '#f2c9a5', fair: '#f6d6bd', tan: '#d9a179', brown: '#a8714a', dark: '#7a4d31' };

/** Герой — сам ученик: без признаков пола (шапка-бини, худи, рюкзак путешественника). */
export const HERO_LOOK: CharLook = {
  skin: SKIN.light,
  hair: '#5a3a26',
  hairStyle: 'beanie',
  top: '#2f6f73',
  bottom: '#2d3142',
  accent: '#f36a1c',
  extras: ['backpack'],
};

export const LOOKS: Record<string, CharLook> = {
  hero: HERO_LOOK,
  nora: { skin: SKIN.fair, hair: '#c4552d', hairStyle: 'long', top: '#27407a', bottom: '#1f2a44', accent: '#f2c14e', extras: ['headset', 'collar'] },
  mia: { skin: SKIN.tan, hair: '#1e1a1d', hairStyle: 'bun', top: '#f2b632', bottom: '#3b4a7a', accent: '#e8505b', extras: [] },
  raj: { skin: SKIN.brown, hair: '#151214', hairStyle: 'short', top: '#7a2836', bottom: '#2a2730', accent: '#e9c46a', extras: ['tie', 'collar'] },
  kai: { skin: SKIN.light, hair: '#e7c35a', hairStyle: 'curly', top: '#3c8c5a', bottom: '#4a5568', accent: '#f4a261', extras: [] },
  sam: { skin: SKIN.dark, hair: '#151214', hairStyle: 'curly', top: '#f1ece2', bottom: '#3d3a36', accent: '#8a5a3c', extras: ['apron'] },
  dave: { skin: SKIN.fair, hair: '#8b8f96', hairStyle: 'cap', top: '#1f3150', bottom: '#1a2236', accent: '#1f3150', extras: ['collar'] },
  ollie: { skin: SKIN.light, hair: '#c86b2c', hairStyle: 'short', top: '#f4f1ea', bottom: '#2f3a52', accent: '#d64545', extras: ['apron'] },
  priya: { skin: SKIN.brown, hair: '#1a1416', hairStyle: 'long', top: '#f4f6f6', bottom: '#2c5f7a', accent: '#3aa17e', extras: ['glasses', 'collar'] },
  tom: { skin: SKIN.fair, hair: '#6b4428', hairStyle: 'short', top: '#6c4fa3', bottom: '#2b2d3a', accent: '#f2c14e', extras: [] },
  arthur: { skin: SKIN.fair, hair: '#e7e3dc', hairStyle: 'bald', top: '#7b6a4e', bottom: '#4a4238', accent: '#2f4f3a', extras: ['glasses', 'beard'] },
  lena: { skin: SKIN.light, hair: '#e3c07a', hairStyle: 'bun', top: '#2e5b9a', bottom: '#20314f', accent: '#e8505b', extras: ['collar'] },
  grace: { skin: SKIN.dark, hair: '#1a1416', hairStyle: 'long', top: '#2f8f6f', bottom: '#2b2d3a', accent: '#f2c14e', extras: [] },
};

export function lookFor(id: string): CharLook {
  return LOOKS[id] ?? LOOKS.tom;
}
